export default __webpack_public_path__ + "static/media/JobSix13.632b26fd.jpg";